import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationService } from 'src/app/services/notification-service';
import { MatPaginator } from '@angular/material/paginator';
import { SuspensionProcessHistoryComponent } from '../suspension-process-history/suspension-process-history.component';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { CustomDatePopupComponent } from '../custom-date-popup/custom-date-popup.component';
import { ReportModalDialogComponent } from '../../Billing/report-modal-dialog/report-modal-dialog.component';

@Component({
  selector: 'app-manage-suspension',
  templateUrl: './manage-suspension.component.html',
  styleUrls: ['./manage-suspension.component.scss']
})
export class ManageSuspensionComponent implements OnInit {
  today: Date = new Date();
  upcomingSchedules: any[] = [];
  dashboardCount: any;
  totalRecords = 0;
  pageNumber = 1;
  pageSize = 20;
  month: string = 'All';
  enableEdit: boolean = true;
  dropdownOpen = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  selectedMonthLabel = '';
  selectedMonthDate: Date = new Date();
  monthNameString: string = "";
  startFlag: boolean = false;
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  private updateMonthLabel(): void {
    const month = this.selectedMonthDate.toLocaleString('default', { month: 'long' });
    const year = this.selectedMonthDate.getFullYear();
    this.selectedMonthLabel = `${month} ${year}`;
    this.monthNameString = this.selectedMonthDate.toLocaleString('default', { month: 'long' });


  }
  displayedColumns: string[] = ['type', 'dorder', 'execDate', 'scheduledBy', 'startedBy', 'status', 'actions'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(SuspensionProcessHistoryComponent) historyComponent: SuspensionProcessHistoryComponent;

  constructor(
    private matdialog: MatDialog,
    private navigate: NavigationService,
    private applicationDataService: ApplicationDataService,
    private toastr: NotificationService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.getDashboardCounts(this.month);
    this.getUpcomingScheduledList(this.month);
    this.updateMonthLabel();
  }

  ngOnInit(): void {
    // Close dropdown when clicking outside
    document.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const dropdownElement = target.closest('.dropdown');

      // Only close if click is outside the dropdown
      if (!dropdownElement) {
        this.closeDropdown();
      }
    }, true); // Use capture phase to ensure it runs after other handlers
  }

  getUpcomingScheduledList(month: string) {
    const payload = {
      monthFilter: month,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    }

    this.applicationDataService.getUpcomingScheduledList(payload).subscribe(
      (result) => {
        this.upcomingSchedules = result.details;
        this.totalRecords = result.totalCount;
        this.upcomingSchedules.forEach(item => {
          const suspensionDate = new Date(item.suspensionDate);

          const isSameDate =
            this.today.getFullYear() === suspensionDate.getFullYear() &&
            this.today.getMonth() === suspensionDate.getMonth() &&
            this.today.getDate() === suspensionDate.getDate();

          if (isSameDate && item.processStatusType === 1) {
            item.startFlag = true;
          }
        });
        this.applyFilter();
      }
    );
  }

  getDashboardCounts(month: string) {
    this.applicationDataService.getSuspensionDashboardCount(month).subscribe(
      (data) => {
        this.dashboardCount = data;
      }
    );
  }

  availableMonths(): string[] {
    const months: string[] = [];
    const today = new Date();
    const year = today.getFullYear();

    for (let month = 0; month < 12; month++) {
      const date = new Date(year, month, 1);
      const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
      months.push(monthName);
    }
    return months;
  }

  // onMonthChange(event?: Event): void {
  //   let val = event ? (event.target as HTMLSelectElement).value : null;
  //   const today = new Date();
  //   const defaultMonth = `01-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;

  //   this.month = (!val || val === 'All')
  //     ? defaultMonth
  //     : `01-${String(new Date(val).getMonth() + 1).padStart(2, '0')}-${new Date(val).getFullYear()}`;

  //   this.getUpcomingScheduledList(this.month);
  //   this.getDashboardCounts(this.month);
  // }

  getTypeStyles(type: string) {
    if (type.includes('Pre-')) return { color: '#c07a00', 'font-weight': '600' };
    if (type.includes('Post-')) return { color: '#0f7a60', 'font-weight': '600' };
    return { color: '#3a006f', 'font-weight': '600' };
  }

  onMonthChange(val?: string): void {
    const today = new Date();
    const defaultMonth = `01-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
    this.monthNameString = today.toLocaleString('default', { month: 'long' });
    if (!val || val === 'All') {
      this.month = defaultMonth;
      this.selectedMonthDate = new Date(today.getFullYear(), today.getMonth(), 1);
      this.monthNameString = this.selectedMonthDate.toLocaleString('default', { month: 'long' });
      this.getUpcomingScheduledList(this.month);
      this.getDashboardCounts(this.month);
    } else if (val === 'Current') {
      this.month = defaultMonth;
      this.selectedMonthDate = new Date(today.getFullYear(), today.getMonth(), 1);
      this.monthNameString = this.selectedMonthDate.toLocaleString('default', { month: 'long' });
      this.getUpcomingScheduledList(this.month);
      this.getDashboardCounts(this.month);
    } else if (val === 'Next') {
      const nextMonthDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      this.month = `01-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${nextMonthDate.getFullYear()}`;
      this.selectedMonthDate = nextMonthDate;
      this.monthNameString = this.selectedMonthDate.toLocaleString('default', { month: 'long' });
      this.getUpcomingScheduledList(this.month);
      this.getDashboardCounts(this.month);
    } else if (val === 'Custom') {
      const dialogref = this.matdialog.open(CustomDatePopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          head: 'Custom Date',
          title: 'date',
          pageName: 'Suspension'
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        this.month = result;
        if (this.month) {
          this.selectedMonthDate = new Date(this.month);
          this.month = `01-${String(new Date(this.month).getMonth() + 1).padStart(2, '0')}-${new Date(this.month).getFullYear()}`;
        }
        this.getUpcomingScheduledList(this.month);
        this.getDashboardCounts(this.month);
        this.updateMonthLabel();

      });
    }
    this.updateMonthLabel();
    this.closeDropdown();
  }
  onPageChange(event: any) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getUpcomingScheduledList(this.month);
  }

  applyFilter(): void {
    this.dataSource.data = this.upcomingSchedules;

    if (this.month === 'All') {
      this.dataSource.data = this.upcomingSchedules;
    } else {
      this.dataSource.data = this.upcomingSchedules.filter(s => {
        const firstDate = s.execDate.split(' ')[0];
        const parts = firstDate.split('-'); // [YYYY, MM, DD]

        if (parts.length === 3) {
          const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1);
          const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
          return monthName === this.month;
        }
        return false;
      });
    }
  }

  filteredSchedules(): any[] {
    return this.dataSource.data;
  }

  deleteData(manageSuspensionId: any): void {
    Swal.fire({
      title: "Are you sure to deactivate this Suspension Schedule?",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Yes',
      showCancelButton: true,
      cancelButtonText: "No"
    }).then(res => {
      if (res.isConfirmed) {
        this.applicationDataService.deleteSuspension(manageSuspensionId).subscribe((data) => {
          if (data) {
            this.toastr.showSuccess('Suspension deleted successfully');
            this.getUpcomingScheduledList(this.month);
            this.getDashboardCounts(this.month);
          }
        });
      }
    });
  }

  EditData(suspensionData: any): void {
    if (suspensionData) {
      this.router.navigate(['/createSuspensionSchedule'], { state: { suspensionData, viewMode: false } });
    } else {
      this.toastr.showError('Suspension data not found');
    }
  }

  ViewData(suspensionData: any): void {
    if (suspensionData) {
      this.router.navigate(['/createSuspensionSchedule'], { state: { suspensionData, viewMode: true } });
    } else {
      this.toastr.showError('Suspension data not found');
    }
  }

  navigateToSuspension() {
    this.navigate.goToSuspensionSchedule();
  }

  refresh() {
    this.getDashboardCounts(this.month);
    this.getUpcomingScheduledList(this.month);
    if (this.historyComponent) {
      this.historyComponent.refresh();
    }
  }

  isDisabled(s: any): boolean {
    const preDate = new Date(s);
    preDate.setHours(0, 0, 0, 0); // normalize
    return preDate >= this.today;
  }


  OpenDialog(type: any, Id: any) {
    debugger
    const dialogRef = this.dialog.open(ReportModalDialogComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: '550px',
      data: {
        displayPanel: type,
        reportType: type == 'suspension' ? 7 : null,
      }
    });

    dialogRef.afterClosed().subscribe(adminUploadedExcelData => {
      debugger
      console.log('Admin Uploaded Excel Data:', adminUploadedExcelData);
      if (adminUploadedExcelData) {
        const dialogRefTable = this.dialog.open(ReportModalDialogComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: 'mat-dialog',
          width: '550px',
          data: {
            displayPanel: 'uploadSuspensionExcelFile',
            reportType: type == 'suspension' ? 7 : null,
            manageSuspensionId: Id,
            tableData: adminUploadedExcelData
          }
        });
        dialogRefTable.afterClosed().subscribe(res => {
          if (res && res === 'CloseAll') {
            this.refresh();
          } else {
            this.OpenDialog('suspension', Id);
          }
        });

      }
    });
  }

  onStart(suspensionData: any): void {

    Swal.fire({
      title: "Start Suspension Process?",
      html: "Please confirm that Money Works allocation is completed and all balances are synced with the system before continuing.",
      icon: "warning",
      showConfirmButton: true,
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No"
    }).then(res => {
      if (res.isConfirmed) {
        this.applicationDataService.startSuspensionProcess(suspensionData.manageSuspensionId).subscribe(
          (data) => {
            if (data) {
              Swal.fire({
                title: "Suspension will commence shortly",
                icon: 'success',
                confirmButtonText: 'OK'
              });
            }
            this.refresh();
          }
        );
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'New': return 'badge-new';
      case 'InProgress': return 'badge-progress';
      case 'Success': return 'badge-success';
      case 'Failed': return 'badge-failed';
      case 'PartialSuccess': return 'badge-partial';
      case 'NotificationSentSuccess': return 'badge-notif-success';
      case 'NotificationFailed': return 'badge-notif-failed';
      case 'AmountPaid': return 'badge-paid';
      case 'ProRataExcluded': return 'badge-excluded';
      case 'SubmittedExcelFile': return 'badge-submitted';
      case 'AdminRemovedCustomer': return 'badge-removed';
      case 'Started': return 'badge-started';
      default: return 'badge-default';
    }
  }

}


